import React from 'react';

import { gql } from '@apollo/client';
import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Stack, Typography } from '@mui/material';

import { SetModuleMemberAsTrainee_ModuleMemberFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import AddToTrainingPlan from './AddToTrainingPlan';

type Props = {
  open: boolean;
  onClose: () => void;
  onUpdate: () => void;
};

type Fragments = {
  moduleMember: SetModuleMemberAsTrainee_ModuleMemberFragment;
};

const SetModuleMemberAsTrainee: FCWithFragments<Fragments, Props> = ({ moduleMember, open, onClose, onUpdate }) => {
  const { t } = useTranslation();
  if (moduleMember.stats?.upcoming) {
    return (
      <Dialog
        submitOptions={{
          label: t('hiring-dashboard-common:common.okay'),
          onClick: onClose,
        }}
        title={t('hiring-dashboard-interviewers:interviewers.setAsTrainee.removeFromUpcomingTitle')}
        subTitle={t('hiring-dashboard-interviewers:interviewers.setAsTrainee.cannotSetSubtitle')}
        open={open}
        onClose={onClose}
      >
        <Stack direction="column" spacing={1}>
          <Typography>{t('hiring-dashboard-interviewers:interviewers.setAsTrainee.scheduledAsTrainedBody')}</Typography>
        </Stack>
      </Dialog>
    );
  }

  return <AddToTrainingPlan moduleMember={moduleMember} open={open} onClose={onClose} onUpdate={onUpdate} />;
};

SetModuleMemberAsTrainee.fragments = {
  moduleMember: gql`
    ${AddToTrainingPlan.fragments.moduleMember}
    fragment SetModuleMemberAsTrainee_moduleMember on InterviewModuleMember {
      id
      employeeId
      interviewModuleId
      stats {
        upcoming
      }
      ...AddToTrainingPlan_moduleMember
    }
  `,
};

export default SetModuleMemberAsTrainee;
